import { vehicleTypeList } from '../../models';
import callApiAxiosClient from '../../axios/axios_client';

function getVehicleTypes(): Promise<vehicleTypeList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<vehicleTypeList>({
    method: 'get',
    url: 'programmability/get-vehicle-types',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
  });
}
export default getVehicleTypes;
